/**
  Autogenerated file. Do not edit manually.
  @openapi https://search-bff.envdevel.com/v3/api-docs
*/

import type {
  AddCustomPlaceBlacklistRequest,
  AddCustomPlaceEvRequest,
  AddCustomPlaceGoogleRequest,
  CustomPlaceBlacklistResponse,
  CustomPlaceResponse,
  GetCustomPlacesParams
} from '../../models';

import { customInstance } from '../../custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * @summary Creates a new custom place based on an existing google place, osm or fotocasa data
 */
export const addCustomPlace = (
    addCustomPlaceGoogleRequest: AddCustomPlaceGoogleRequest,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/autosuggestion/data/custom-places/google`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addCustomPlaceGoogleRequest
    },
      options);
    }
  /**
 * @summary Create a new custom place based on a new (invented) place
 */
export const addCustomPlace1 = (
    addCustomPlaceEvRequest: AddCustomPlaceEvRequest,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/autosuggestion/data/custom-places/ev`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addCustomPlaceEvRequest
    },
      options);
    }
  /**
 * @summary Add a placeId to the blacklist
 */
export const addCustomPlaceBlacklistEntry = (
    addCustomPlaceBlacklistRequest: AddCustomPlaceBlacklistRequest,
 options?: SecondParameter<typeof customInstance<CustomPlaceBlacklistResponse>>,) => {
      return customInstance<CustomPlaceBlacklistResponse>(
      {url: `/api/v1/autosuggestion/data/custom-places/blacklist`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addCustomPlaceBlacklistRequest
    },
      options);
    }
  /**
 * @summary Get all registered custom places
 */
export const getCustomPlaces = (
    params?: GetCustomPlacesParams,
 options?: SecondParameter<typeof customInstance<CustomPlaceResponse[]>>,) => {
      return customInstance<CustomPlaceResponse[]>(
      {url: `/api/v1/autosuggestion/data/custom-places`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Delete a custom place
 */
export const deleteCustomPlace = (
    placeId: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/autosuggestion/data/custom-places/${placeId}`, method: 'DELETE'
    },
      options);
    }
  /**
 * @summary Delete a customplace autosuggestion blacklisting entry
 */
export const deleteCustomPlaceBlacklistEntry = (
    placeId: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/autosuggestion/data/custom-places/blacklist/${placeId}`, method: 'DELETE'
    },
      options);
    }
  export type AddCustomPlaceResult = NonNullable<Awaited<ReturnType<typeof addCustomPlace>>>
export type AddCustomPlace1Result = NonNullable<Awaited<ReturnType<typeof addCustomPlace1>>>
export type AddCustomPlaceBlacklistEntryResult = NonNullable<Awaited<ReturnType<typeof addCustomPlaceBlacklistEntry>>>
export type GetCustomPlacesResult = NonNullable<Awaited<ReturnType<typeof getCustomPlaces>>>
export type DeleteCustomPlaceResult = NonNullable<Awaited<ReturnType<typeof deleteCustomPlace>>>
export type DeleteCustomPlaceBlacklistEntryResult = NonNullable<Awaited<ReturnType<typeof deleteCustomPlaceBlacklistEntry>>>
